import React, { useEffect, useState } from "react";
import { Button } from "src/components/ui/Button";
import CloseSvg from "src/assets/images/svg/CloseSvg";

const ANIMATION_DURATION = 300;

const FilePreviewModal = ({
  isOpen,
  onClose,
  fileContent,
  fileName,
  fileType,
  title,
}) => {
  const [shouldRender, setShouldRender] = useState(isOpen);
  const [isVisible, setIsVisible] = useState(isOpen);

  useEffect(() => {
    let timeoutId;
    let rafId;
    if (isOpen) {
      setShouldRender(true);
      rafId = requestAnimationFrame(() => {
        setIsVisible(true);
      });
    } else {
      setIsVisible(false);
      timeoutId = setTimeout(() => {
        setShouldRender(false);
      }, ANIMATION_DURATION);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      if (rafId) {
        cancelAnimationFrame(rafId);
      }
    };
  }, [isOpen]);

  if (!shouldRender) {
    return null;
  }

  const isPdf = (fileType || "").includes("pdf");
  const modalTitle = title || fileName || "Preview";

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center p-4 transition-opacity duration-300 ${isVisible ? "opacity-100" : "opacity-0 pointer-events-none"}`}
      role="dialog"
      aria-modal="true"
      aria-label={modalTitle}
      onClick={onClose}
    >
      <div className="absolute inset-0 bg-Gray950/70" />
      <div
        className={`relative bg-Gray50 rounded-2xl w-full max-w-[520px] shadow-lg overflow-hidden transition-all duration-300 ${isVisible ? "scale-100 opacity-100" : "scale-95 opacity-0"}`}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex items-center justify-between px-6 py-4">
          <div className="text-h6 font-semibold text-Gray950 truncate pr-4">
            {modalTitle}
          </div>
          <Button
            type="text"
            htmlType="button"
            shape="circle"
            aria-label="Close preview"
            onClick={onClose}
            className="p-1 hover:bg-Gray100 focus:outline-none"
            icon={<CloseSvg />}
          />
        </div>
        <div className="p-6 min-h-[320px] flex items-center justify-center">
          {fileContent ? (
            isPdf ? (
              <iframe
                title="Document preview"
                src={fileContent}
                className="w-full h-[420px] rounded-xl border border-Gray200"
              />
            ) : (
              <img
                src={fileContent}
                alt={modalTitle}
                className="max-h-[420px] w-full object-contain rounded-xl border border-Gray200"
              />
            )
          ) : (
            <p className="text-body text-Gray700 text-center">
              Preview unavailable for this file type.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default FilePreviewModal;
